module.exports = __webpack_public_path__ + "img/status_schedule_update_of_system_classifications.b95c29b1.gif";